module.exports = __webpack_public_path__ + "media/bootstrap-icons/type-strikethrough-f20e1b4d.svg";